import { z } from "zod";

const nullableNumber = z
  .union([z.number(), z.string()])
  .nullish()
  .transform((value) => (value == null || value === "" ? null : Number(value)));

const numberValue = z
  .union([z.number(), z.string()])
  .transform((value) => Number(value));

export const dropdownOptionSchema = z.object({
  value: numberValue,
  label: z.string(),
});

export const receivingItemSchema = z.object({
  id: numberValue.optional(),
  barcode: z.string(),
  ingredient_id: numberValue,
  product_name: z.string().nullish(),
  lot_number: z.string().nullish(),
  received_amount: numberValue.default(0),
  in_stock: numberValue.default(0),
  ingredient_amount_used: numberValue.default(0),
  unit_of_measure: z.string().nullish(),
});

export const recipeItemSchema = z.object({
  id: numberValue,
  bom_id: nullableNumber,
  ingredient_id: nullableNumber,
  bom_name: z.string().nullish(),
  amount_in_use: nullableNumber,
  amount_required: nullableNumber,
  unit_of_measure_label: z.string().nullish(),
  receivingItems: z.array(receivingItemSchema).default([]),
});

export const productionMutationSchema = z.object({
  message: z.string().optional(),
  recipe_items: z.array(recipeItemSchema).default([]),
});

export const productionScannedItemsSchema = z.object({
  recipe_items: z.array(recipeItemSchema).default([]),
});

export const receivingItemResponseSchema = z
  .union([
    z.object({ receiving_item: receivingItemSchema }),
    receivingItemSchema,
  ])
  .transform((response) =>
    "receiving_item" in response ? response.receiving_item : response,
  );
